import { JsonObject, JsonProperty } from 'json2typescript';
import { Department } from './department';
import { LawyerLevel } from './lawyerLevel';

@JsonObject('LawyerBase')
export class LawyerBase {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('name', String, true)
    name = null;

    @JsonProperty('name_ar', String, true)
    nameAr = null;

    @JsonProperty('initials', String, true)
    initials = null;

    @JsonProperty('appointed_date', String, true)
    appointedDate = null;

    @JsonProperty('rate', Number, true)
    rate = undefined;

    @JsonProperty('city', String, true)
    city = null;

    @JsonProperty('country', String, true)
    country = null;

    @JsonProperty('can_edit_timesheets', Boolean, true)
    canEditTimesheets = false;

    @JsonProperty('phone', String, true)
    phone = null;

    @JsonProperty('email', String, true)
    email = null;

    get getName() {
        return this.nameAr || this.name;
    }
}

@JsonObject('Lawyer')
export class Lawyer extends LawyerBase {
    @JsonProperty('user', Number, true)
    userId: number = undefined;

    @JsonProperty('address', String, true)
    address = null;

    @JsonProperty('phone', String, true)
    phone = null;

    @JsonProperty('fax', String, true)
    fax = null;

    @JsonProperty('email', String, true)
    email = null;

    @JsonProperty('level', LawyerLevel, true)
    level: LawyerLevel = null;

    @JsonProperty('level_id', Number, true)
    levelId = null;

    @JsonProperty('departments', [Department], true)
    departments: Department[] = [];

    @JsonProperty('code', String, true)
    lawyerCode = null;

    @JsonProperty('tax_num', String, true)
    taxationNumber = null;

    @JsonProperty('social_id', String, true)
    socialID = null;

    @JsonProperty('last_timesheet_entry_date', String, true)
    lastTimesheet = null;

    @JsonProperty('events_on_date', Boolean, true)
    eventsOnDate: boolean = false;

    get getLevel() {
        return this.level?.getName;
    }

    get getDept() {
        return this.departments.map(d => d?.name).join(', ');
    }

    public get location(): string {
        let l = "";
        l = this.address ? this.address + ", " : "";
        l += this.city ? this.city + ", " : "";
        l += this.country ? this.country : "";

        return (this.address || this.city || this.country) ? l : '—';
    }
}

@JsonObject('LawyerLite')
export class LawyerLite extends LawyerBase {
    @JsonProperty('level', String, true)
    level: string | LawyerLevel = null;
}

@JsonObject('LawyerTiny')
export class LawyerTiny extends LawyerBase { }
